(function(){
    'use strict'

    angular.module('app.core')
    .factory('PreventTemplateCacheInterceptor', PreventTemplateCacheInterceptor);

    PreventTemplateCacheInterceptor.$inject = ['inscripcionVersion'];

    function PreventTemplateCacheInterceptor(inscripcionVersion) {
        
        var preventTemplateCacheInterceptor = {  
            request: function (config) {  
                
                if (config.url.indexOf('uib') === -1 && config.url.indexOf('.html') !== -1) {
                    config.url = config.url + '?t=' + inscripcionVersion;
                  }

                return config;  
            } 
        };  
  
        return preventTemplateCacheInterceptor;  
    }
})();